export default __webpack_public_path__ + "0c21250.png";